import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { ErrorService } from '@app/_services/error.service';
import { SavviMachineService } from '@app/_xstate/savvi-machine.service';
import { HandleError } from '@app/_xstate/savvi-machine.events';

@Injectable({
	providedIn: 'root'
})
export class PermissionsGuard implements CanActivate {
	constructor(
		private router: Router,
		private permissionsService: NgxPermissionsService,
		private errorService: ErrorService,
		private savviMachineService: SavviMachineService
	) {}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const hasPermission = this.permissionsService.getPermission('can_access_app');
		console.log('PermissionsGuard', hasPermission);

		if (hasPermission) {
			return true;
		} else {
			this.errorService.setErrorCode('noAppPermission');
			this.savviMachineService.send(new HandleError('Sie haben keine Berechtigung, auf diese Seite zuzugreifen.'));
			// this.router.navigate(['/request-error'], {
			// 	state: { errorMessage: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.' }
			// });
			return false;
		}
	}
}
